import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config } from '../config';
import { RpcError, toRpcError } from './errors';
import { session } from '../core/session';

let client: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  // 参加者は Supabase Auth を使わない（チームの鍵で RPC に認証する）ので、Auth のセッション保存を切る
  client ??= createClient(config.supabaseUrl, config.anonKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  });
  return client;
}

const TIMEOUT_MS = 15_000;

export async function callRpc<T>(fn: string, params: Record<string, unknown>): Promise<T> {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), TIMEOUT_MS);
  try {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) throw new RpcError('network', 'offline');
    const { data, error } = await supabase().rpc(fn, params).abortSignal(ctrl.signal);
    if (error) throw toRpcError(error);
    return data as T;
  } catch (e) {
    if (ctrl.signal.aborted) throw new RpcError('network', 'timeout');
    const err = toRpcError(e);
    if (err.code === 'invalid_session') session.expire();
    throw err;
  } finally {
    clearTimeout(timer);
  }
}

export function callAuthed<T>(fn: string, params: Record<string, unknown>): Promise<T> {
  const token = session.token();
  if (!token) return Promise.reject(new RpcError('invalid_session'));
  return callRpc<T>(fn, { p_token: token, ...params });
}
